import { css } from 'glamor';

export default css({
  minWidth: 40,
});
